module.exports = __webpack_public_path__ + "static/media/peersona.7f000cb9.png";